/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_decrease_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If something is discounted 50% twice, is that the same as 100% off?`)
};

const es_pct_decrease_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si algo tiene un 50% de descuento dos veces, ¿es lo mismo que un 100% de descuento?`)
};

const de_pct_decrease_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn etwas zweimal um 50% reduziert wird, ist das dasselbe wie 100% Rabatt?`)
};

const nl_pct_decrease_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als iets twee keer 50% korting krijgt, is dat dan hetzelfde als 100% korting?`)
};

const fr_pct_decrease_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si un article est réduit de 50 % deux fois, est-ce la même chose qu’une réduction de 100 % ?`)
};

const it_pct_decrease_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se qualcosa è scontato del 50% due volte, equivale al 100% di sconto?`)
};

const pt_br2_pct_decrease_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se algo tem 50% de desconto duas vezes, isso é o mesmo que 100% de desconto?`)
};

const pt_pct_decrease_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se algo tiver 50% de desconto duas vezes, isso é o mesmo que 100% de desconto?`)
};

const ja_pct_decrease_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`50%オフを2回適用すると、100%オフと同じになりますか？`)
};

const zh_pct_decrease_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打两次 50% 的折扣等于 100% 免费吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_decrease_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_decrease_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_decrease_faq3_q", locale)
	if (locale === "en") return en_pct_decrease_faq3_q(inputs)
	if (locale === "es") return es_pct_decrease_faq3_q(inputs)
	if (locale === "de") return de_pct_decrease_faq3_q(inputs)
	if (locale === "nl") return nl_pct_decrease_faq3_q(inputs)
	if (locale === "fr") return fr_pct_decrease_faq3_q(inputs)
	if (locale === "it") return it_pct_decrease_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_pct_decrease_faq3_q(inputs)
	if (locale === "pt") return pt_pct_decrease_faq3_q(inputs)
	if (locale === "ja") return ja_pct_decrease_faq3_q(inputs)
	return zh_pct_decrease_faq3_q(inputs)
};